import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { NavigationService } from '../services/navigation.service';
import { StorageItems } from '../constants/storage-items.constants';
import { collection, FBaseService } from '../services/firebase/f-base.service';
import { ModalService } from '../services/modal.service';
import { UserService } from '../services/user.service';

export const AuthGuard = async (data: any) => {
  const authService = inject(AuthService);
  const fbService = inject(FBaseService);
  const router = inject(Router);
  const navigationService = inject(NavigationService);
  const modalService = inject(ModalService);
  const userService = inject(UserService);

  let firebaseUser: any;
  let user: any;
  try {
    firebaseUser = await firstValueFrom(authService.currentUserObservable());

    if (!firebaseUser || !firebaseUser.uid) {
      localStorage.removeItem(StorageItems.USERID);
      navigationService.navigateRootInstant('login');
      return false;
    }

    user = await firstValueFrom(fbService.getById(collection.users, firebaseUser.uid));

    if (!user) {
      try {
        await authService.logout();
      } catch (logoutError) {
        console.error('Orphan cleanup logout error:', logoutError);
      }
      localStorage.removeItem(StorageItems.USERID);
      navigationService.navigateRootInstant('login');
      return false;
    }

    localStorage.setItem(StorageItems.USERID, firebaseUser.uid);

    if (!user.privacyPolicyAccepted) {
      const currentUrl = router.url;
      if (!currentUrl.includes('privacy-policy')) {
        navigationService.navigateRootInstant('privacy-policy');
        return false;
      }
      return true;
    }

    if (!user.name || String(user.name).trim().length < 3) {
      const modalResult = await modalService.showNameRequiredModal();
      if (modalResult.logout) {
        try {
          await authService.logout();
        } catch (error) {
          console.error('Logout error:', error);
        }
        localStorage.removeItem(StorageItems.USERID);
        navigationService.navigateRootInstant('login');
        return false;
      }
      user.name = modalResult.name!;
      await userService.update(user);
    }

    return true;

  } catch (error) {
    console.error('Authentication error:', error);
    localStorage.removeItem(StorageItems.USERID);
    return router.parseUrl('login');
  }
};
